import * as cdLogger from 'services/cdLogger';

const isStorageAvailable = () => {
  try {
    localStorage.setItem('____availability_test', 'true');
    if (localStorage.getItem('____availability_test') === 'true') {
      // localStorage is enabled
      localStorage.removeItem('____availability_test');
      return true;
    }
    // localStorage is disabled
    throw new Error('local storage is disabled');
  } catch (e) {
    // localStorage is disabled or not available
    return false;
  }
};

class LocalStorageService {
  constructor() {
    this.isStorageAvailable = isStorageAvailable();
  }

  setItem = (key, value) => {
    if (!this.isStorageAvailable) return;

    localStorage.setItem(key, value);
  };

  getItem = key => {
    if (!this.isStorageAvailable) return;

    return localStorage.getItem(key);
  };

  getParsedItem = key => {
    if (!this.isStorageAvailable) return;

    try {
      const parsedItem = JSON.parse(localStorage.getItem(key));
      return parsedItem;
    } catch (err) {
      cdLogger.error(err);
    }
  };

  removeItem = key => {
    if (!this.isStorageAvailable) return;

    localStorage.removeItem(key);
  };

  clearShowAlertSiblingsFromStorage = ({ prefix }) => {
    if (!this.isStorageAvailable) {
      return;
    }

    Object.keys(localStorage).forEach(key => {
      const hasShowAlertText = key.indexOf('_show_alert') !== -1;
      const hasPrefixText = key.indexOf(prefix) !== -1;
      const isSibling = hasShowAlertText && hasPrefixText;
      if (isSibling) {
        localStorage.removeItem(key);
      }
    });
  };
}

export default new LocalStorageService();
